import { Link, NavLink } from "react-router-dom";
import { Flame } from "lucide-react";
import { BUSINESS, NAV_LINKS } from "../data/site";
import { CallButton, TextPhotoButton } from "./CTA";

const Navbar = () => (
  <header data-testid="site-header" className="sticky top-0 z-50 bg-coal text-cream border-b border-white/10">
    <div className="max-w-7xl mx-auto px-3 sm:px-6 flex items-center justify-between gap-2 h-16 md:h-20">
      <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 shrink min-w-0 group">
        <span className="grid place-items-center w-8 h-8 sm:w-9 sm:h-9 bg-rust text-cream btn-cut shrink-0" aria-hidden>
          <Flame size={18} strokeWidth={2.4} />
        </span>
        <span className="font-display font-black uppercase tracking-tight leading-none text-[11px] sm:text-base truncate">
          <span className="sm:hidden">Aledo <span className="text-rust">Welding</span></span>
          <span className="hidden sm:inline">Aledo<br /><span className="text-rust"> Welding</span></span>
        </span>
      </Link>
      <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
        {NAV_LINKS.map((l) => (
          <NavLink
            key={l.path}
            to={l.path}
            data-testid={`nav-${l.name.toLowerCase().replace(/\s+/g, "-")}`}
            className={({ isActive }) =>
              `text-sm font-semibold tracking-wide transition-colors duration-150 ${
                isActive ? "text-rust" : "text-cream/80 hover:text-cream"
              }`
            }
          >
            {l.name}
          </NavLink>
        ))}
      </nav>
      <div className="flex items-center gap-1.5 sm:gap-2 shrink-0">
        <CallButton compact dark testid="header-call-btn" />
        <TextPhotoButton compact testid="header-text-btn" />
      </div>
    </div>
    <nav className="lg:hidden border-t border-white/10 overflow-x-auto" aria-label="Mobile">
      <div className="flex gap-5 px-4 py-2 whitespace-nowrap">
        {NAV_LINKS.map((l) => (
          <NavLink
            key={l.path}
            to={l.path}
            data-testid={`nav-mobile-${l.name.toLowerCase().replace(/\s+/g, "-")}`}
            className={({ isActive }) =>
              `text-xs font-semibold uppercase tracking-wider ${isActive ? "text-rust" : "text-cream/70"}`
            }
          >
            {l.name}
          </NavLink>
        ))}
      </div>
    </nav>
  </header>
);

export default Navbar;
